<button
  type="button"
  [class]="buttonClass()"
  [attr.aria-label]="ariaLabel()"
  [title]="ariaLabel()"
  (click)="toggleTheme()"
>
  @if (isDarkTheme()) {
    <svg
      class="{{ iconClass() }}"
      [attr.viewBox]="iconViewBox()"
      aria-hidden="true"
      focusable="false"
    >
      <use href="/assets/icons/sprite.svg#sun"></use>
    </svg>
  } @else {
    <svg
      class="{{ iconClass() }}"
      [attr.viewBox]="iconViewBox()"
      aria-hidden="true"
      focusable="false"
    >
      <use href="/assets/icons/sprite.svg#moon"></use>
    </svg>
  }
</button>
